
define('app/board/views/teamRosterView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickSummaryCollection',
	'app/board/collections/rosterPositionCollection',
	'known/models/leagueInstanceModel',
	'known/models/userModel',
	'app/board/models/pickModel',
	'app/board/views/teamHeaderView',
	
	//Templates
	'text!app/board/templates/rosterBoardTemplate.html'
], function($, _, Backbone, PickSummaryCollection, RosterPositionCollection, LeagueInstanceModel, UserModel, PickModel, TeamHeaderView, rosterBoardHtml){
	var PickView = Backbone.View.extend({
		initialize: function(options) {
			this.draftOptions = options.draftOptions;
			this.posColors = options.posColors;
			this.leagueInst = options.leagueInst;
			this.lgPos = options.lgPos;
			this.lgPosRank = options.lgPosRank;
			this.teamPos = options.teamPos;
			this.defaultEmpty = options.defaultEmpty;
			this.firstRender = false;
			this.hidden = this.defaultEmpty;
			
			this.template = _.template(rosterBoardHtml.trim());
			
			this.listenTo(this.draftOptions, 'change', this.setPickStyles);
			this.listenTo(this.posColors, 'change', this.setPickStyles);
		},
		
		updateValues: function (pickSummary) {
			this.hidden = false;
			
			var playerPos = '&nbsp;';
			var playerTeam = '&nbsp;';
			var playerBye = '&nbsp;';
			var firstName = '&nbsp;';
			var lastName = this.lgPos != null ? this.lgPos.get('id') : 'Bench';
			var isKeeper = false;
			
			if(pickSummary){
				firstName = pickSummary.get('fName') ? pickSummary.get('fName') : '&nbsp;';
				
				if(pickSummary.get('lName') && pickSummary.get('keeper')){
					lastName = pickSummary.get('lName') + '<sup>(K)</sup>';
				} else if(pickSummary.get('lName') && pickSummary.get('autoDrafted')){
					lastName = pickSummary.get('lName') + '<sup>(A)</sup>';
				} else if(pickSummary.get('lName')){
					lastName = pickSummary.get('lName');
				}
				
				if(this.leagueInst.get('draftType') == 'AUCTION'
					&& pickSummary.get('auctionValue') 
					&& pickSummary.get('auctionValue') > 0){
				lastName = '$' + pickSummary.get('auctionValue') + ' ' + lastName;
			}
				
				playerPos = pickSummary.get('playerPos') ? pickSummary.get('playerPos') : '&nbsp;';
				playerTeam = pickSummary.get('teamAbbr') ? pickSummary.get('teamAbbr') : '&nbsp;';
				playerBye = (pickSummary.get('byeWeek') && pickSummary.get('byeWeek') > 0) ? pickSummary.get('byeWeek') : '&nbsp;';
				isKeeper = pickSummary.get('keeper') ? true : false;
			} else if(this.defaultEmpty){
				lastName = '&nbsp;';
				this.hidden = true;
			}
			
			$(this.el).find('.playerPos').html(playerPos);
			$(this.el).find('.playerTeam').html(playerTeam);
			$(this.el).find('.playerBye').html(playerBye);
			$(this.el).find('.playerFName').html(firstName);
			$(this.el).find('.playerLName').html(lastName);
			
			if(isKeeper){
				$(this.el).addClass('keeper');
			} else {
				$(this.el).removeClass('keeper');
			}
			
			this.setPickStyles();
			
			return this;
		},
		
		render: function () {
			var pos = this.lgPos != null ? this.lgPos.get('id') : 'Bench';
			if(this.hidden){
				pos = '&nbsp;';
			}
			
			var html = $(this.template({
				teamPos: this.teamPos,
				pos: pos,
				posId: this.lgPos != null ? this.lgPos.get('id').replace(',','.') : 'BENCH',
				posRank: this.lgPosRank}));
			
			this.setPickElStyle(html);
			
			if(this.firstRender == true){
				this.el = html;
				//this.setElement(html);
				this.firstRender = false;
			} else {
				var oldEl = $(this.el);
				
				this.setElement(html);
				oldEl.replaceWith(html);
			}
			
			return this;
		},
		
		setPickStyles: function() {
			this.setPickElStyle(this.el);
		},
		
		setPickElStyle: function(el) {
			var pos = $(el).find('.playerPos').html();
			var color = this.posColors.retrievePosColor(pos);
			
			if(this.hidden){
				$(el).addClass('emptyPickSpace');
				color = '';
			} else {
				$(el).removeClass('emptyPickSpace');
			}
			
			$(el).css({
				'font-size': this.draftOptions.get('fontSize') + 'px', 
				'line-height': this.draftOptions.get('fontHeight') + 'px',
				'min-width': this.draftOptions.get('pickWidth') + 'px', 
				'max-width': this.draftOptions.get('pickWidth') + 'px',
				'background-color': color,
				'padding-top': Math.ceil(this.draftOptions.get('playerLargeFontSize')/20) + 'px',
		    	'padding-right': Math.ceil(this.draftOptions.get('playerLargeFontSize')/10) + 'px',
		    	'padding-bottom': Math.ceil(this.draftOptions.get('playerLargeFontSize')/20) + 'px',
		    	'padding-left': Math.ceil(this.draftOptions.get('playerLargeFontSize')/10) + 'px',});
			/*$(el).css({
				'font-size': this.draftOptions.get('fontSize') + 'px', 
				'line-height': this.draftOptions.get('fontHeight') + 'px',
				'width': this.draftOptions.get('pickWidth') + 'px',
				'background-color': color}); */ //Fixed Header Revert
			$(el).find(".playerFName").css({
				'font-size': this.draftOptions.get('playerSmallFontSize') + 'px', 
				'line-height': this.draftOptions.get('playerSmallFontHeight') + 'px',
			    'padding-top': Math.ceil(this.draftOptions.get('playerLargeFontSize')/8) + 'px'});
			$(el).find(".playerLName").css({
				'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
				'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
			$(el).parent().find(".draftRound").css({
				'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
				'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
			
			if(this.draftOptions.get('hideFName')){
				$(el).find(".playerFName").css({'display': 'none'});
				$(el).find(".playerLName").css({'clear': 'none'});
			} else {
				$(el).find(".playerFName").css({'display': ''});
				$(el).find(".playerLName").css({'clear': 'both'});
			}
			
			if(this.draftOptions.get('hidePlayerInfo')){
				$(el).find(".playerPos").css({'display': 'none'});
				$(el).find(".playerTeam").css({'display': 'none'});
				$(el).find(".playerBye").css({'display': 'none'});
			} else {
				$(el).find(".playerPos").css({'display': ''});
				$(el).find(".playerTeam").css({'display': ''});
				$(el).find(".playerBye").css({'display': ''});
			}
			
			if(this.draftOptions.get('hideRoundPosInfo')){
				$(el).find(".roundPos").css({'display': 'none'});
			} else {
				$(el).find(".roundPos").css({'display': ''});
			}
		}
	});
	
	var DraftBoardView = Backbone.View.extend({
		el: $("#teamRosterTable"),
		
		initialize: function(options) {
			this.leagueInst = options.leagueInst;
			this.user = options.user;
			this.pickSummaries = options.pickSummaryCollection; 
			this.draftOptions = options.draftOptions; 
			this.posColors = options.posColors; 
			this.draftStatusModel = options.draftStatusModel;
			this.rosterPositionCollection = options.rosterPositionCollection;
			
			this.pickViews = [];
			this.teamViews = [];
			
			this.listenTo(this.pickSummaries, 'reset', this.populateAllRosters);
			this.listenTo(this.pickSummaries, 'change', this.updateTeamRoster);
		},
		
		render: function () {		
			this.$(".fantTeamNameRow").empty();
			this.$("tbody").empty();
			this.renderTeams();
			this.renderPositions();
			this.populateAllRosters();
			
			return this;
		},
		
		populateAllRosters: function() {
			this.leagueInst.get('fantasyTeams').each(function(team) {
				this.populateRoster(team);
			}, this);
		},
		
		updateTeamRoster: function(pickSummary) {
			if(pickSummary){
				var team = this.leagueInst.get('fantasyTeams').get(pickSummary.get('fantasyTeamId'));
				if(team) {
					this.populateRoster(team);
				}
			}
			 
		},
		
		populateRoster:function(fantTeam) {
			var posMap = this.draftStatusModel.get('teamPosMap')[fantTeam.get('id')]; // {lgPosId : [PosRoundId]}
			var maxNumPicks = this.draftStatusModel.get('teamMaxNumPicks')[fantTeam.get('id')]; 
			var processedPicks = {};
			var pickSummaries = this.pickSummaries;
			var pickViews = this.pickViews; 
			var sortFunc = this.sortNumber;
			var leagueInst = this.leagueInst;
			this.leagueInst.get('leaguePositions').each(function(lgPos) {
				var pickArr = posMap[lgPos.get('id')];
				if(pickArr && pickArr.length > 0){
					pickArr = pickArr.sort(sortFunc);
				} else {
					pickArr = {};
				}
				
				var startersFound = 0;
				var i = 1;
				while(startersFound < lgPos.get('starters') && i <= pickArr.length){
					var pickView = pickViews[fantTeam.get('draftPosition') + '_' + lgPos.get('id').replace(',','.') + '_' + (startersFound+1)];
					if(!processedPicks[pickArr[i-1]]){
						var pickSummary = null;						
						if(leagueInst.get('draftType') == 'AUCTION') {
							pickSummary = pickSummaries.getAucPickByPosRoundId(pickArr[i-1]);
						} else {
							pickSummary = pickSummaries.get(pickArr[i-1]);
						}
						
						pickView.updateValues(pickSummary);
						processedPicks[pickArr[i-1]] = true;
						startersFound++;
					}
					
					i++;
				}
				
				for(var i=(startersFound+1); i<=lgPos.get('starters'); i++){
					var pickView = pickViews[fantTeam.get('draftPosition') + '_' + lgPos.get('id').replace(',','.') + '_' + i];
					pickView.updateValues(null);
				}
			}, this);
			
			//Get all of this team's draft picks
			var allPosArr = posMap['ALL_POSITIONS'];
			if(allPosArr && allPosArr.length > 0){
				allPosArr = allPosArr.sort(this.sortNumber);
			} else {
				allPosArr = [];
			}
			
			//Get the max number of bench picks any team has made
			var benchData = $(this.el).data("benchData");
			var maxAllBenchNum = 0;
			if(benchData) {
				for(var fantTeamId in benchData) {
					if(benchData[fantTeamId] > maxAllBenchNum && fantTeamId != fantTeam.get('id')){
						maxAllBenchNum = benchData[fantTeamId]; 
					}
				}
			} else {
				benchData = {};
				$(this.el).data("benchData", benchData);
			}
						
			//Add Bench positions
			var numBenchSpots = 0;
			for (var i = 1; i <= maxNumPicks; i++) {
				var pickView = pickViews[fantTeam.get('draftPosition') + '_' + 'BENCH' + '_' + (numBenchSpots + 1)];
				if(i <= allPosArr.length && !processedPicks[allPosArr[i-1]]){
					var pickSummary = null;						
					if(this.leagueInst.get('draftType') == 'AUCTION') {
						pickSummary = pickSummaries.getAucPickByPosRoundId(allPosArr[i-1]);
					} else {
						pickSummary = pickSummaries.get(allPosArr[i-1]);
					}
					
					pickView.updateValues(pickSummary);
					processedPicks[allPosArr[i-1]] = true;
					numBenchSpots++;
				}
			}
			
			for (var i = 1; i <= maxNumPicks; i++) {
				var row = $('#rosterRowBench_' + i);
				if(i > numBenchSpots){
					var pickView = pickViews[fantTeam.get('draftPosition') + '_' + 'BENCH' + '_' + i];
					pickView.updateValues(null);
				}
				
				if(i > numBenchSpots && row.hasClass('defaultHiddenRow') && maxAllBenchNum < i){
					row.hide();
				} else {
					row.show();
				}
			}
			
			benchData[fantTeam.get('id')] = numBenchSpots; 
			$(this.el).data("benchData", benchData);			
		},
		
		renderTeams: function () {
			var sortedTeams = this.leagueInst.getTeamList();
			
			//this.$(".fantTeamNameRow").append('<th class="draftRound">&nbsp;</th>'); // Fixed Header Revert
			this.$(".fantTeamNameRow").append('<th>&nbsp;</th>');
			
			_.each(sortedTeams, function(team){
				var teamView = new TeamHeaderView({
						leagueUser: this.leagueInst.get("leagueUsers").get(team.get('leagueUserId')), 
						fantasyTeam: team,
						draftOptions: this.draftOptions,
						user: this.user,
						leagueInst: this.leagueInst,
						draftStatusModel: this.draftStatusModel});
				this.$(".fantTeamNameRow").append(teamView.render().el);
				this.teamViews[team.get('draftPosition')] = teamView;
			}, this);
		},
		
		renderPositions: function () {
			var numTeams = this.leagueInst.numTeams();
			var maxNumPicksMap = this.draftStatusModel.get('teamMaxNumPicks');
			var maxNumPicks = 0;
			var numStarters = 0;
			
			for(var fantTeamId in maxNumPicksMap) {
				if(maxNumPicksMap[fantTeamId] > maxNumPicks){
					maxNumPicks = maxNumPicksMap[fantTeamId]; 
				}
			}
			
			//Add a row for each starting position
			this.leagueInst.get('leaguePositions').each(function(lgPos) {
				for(var i=1; i<=lgPos.get('starters'); i++){
					var roundRow = $('<tr></tr>');
					
					var name = lgPos.get('name') != "FLEX" ? lgPos.get('name') : "Flex";
					
					roundRow.append('<td class="draftRound">' + name + '</td>');
					
					roundRow.find(".draftRound").css({
						'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
						'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
					
					for (var j = 1; j <= numTeams; j++) {
						var pickView = new PickView({
								teamPos: j,
								lgPos: lgPos, 
								lgPosRank: i,
								leagueInst: this.leagueInst,
								draftOptions: this.draftOptions,
								posColors: this.posColors,
								defaultEmpty: false});
						roundRow.append(pickView.render().el);
						this.pickViews[j + '_' + lgPos.get('id').replace(',','.') + '_' + i] = pickView;
					}
					
					this.$("tbody").append(roundRow);
					
					numStarters++;
				}
				
			}, this);			
			
			//Add Bench Rows
			for (var i = 1; i <= maxNumPicks; i++) {
				var roundRow = $('<tr id="rosterRowBench_' + i + '"></tr>');
				
				if(maxNumPicks < (numStarters + i)){
					roundRow.hide();
					roundRow.addClass('defaultHiddenRow');
				}
				
				roundRow.append('<td class="draftRound">' + 'Bn' + '</td>');
				
				roundRow.find(".draftRound").css({
					'font-size': this.draftOptions.get('playerLargeFontSize') + 'px', 
					'line-height': this.draftOptions.get('playerLargFontHeight') + 'px'});
				
				for (var j = 1; j <= numTeams; j++) {
					var defaultEmpty = false;
					var curTeam = this.leagueInst.getTeamByDraftPosition(j);
					if(maxNumPicksMap[curTeam.get('id')] < (i + numStarters)){
						defaultEmtpy = true;
					}
					
					var pickView = new PickView({
						teamPos: j,
						lgPos: null, 
						lgPosRank: i,
						leagueInst: this.leagueInst,
						draftOptions: this.draftOptions,
						posColors: this.posColors,
						defaultEmpty: defaultEmpty});
					roundRow.append(pickView.render().el);
					this.pickViews[j + '_' + 'BENCH' + '_' + i] = pickView;
				}
				
				this.$("tbody").append(roundRow);
			}
			
			
		},
		
		sortNumber: function (a,b) {
			//We want auction keepers to always be sorted ahead of non-keepers
			//Auction keepers closer to 0 should be sorted ahead of larger ones.
			if(a > 0 && b > 0){
				return a - b;
			} else if(a > 0){
				return 1;
			} else if(b > 0){
				return -1;
			} else {
				return Math.abs(a) - Math.abs(b);
			}   
		}
	});
	
	return DraftBoardView;  
});